<template>
 <div class="orgDetialBox">
   <el-scrollbar style="height: calc(100vh - 174px)">
     <el-form label-position="top" label-width="180px" :model="org_info">
       <div class="paneOne">
         <el-form-item label="Organization ID">{{ org_info.organization_number }}</el-form-item>
         <el-form-item label="Business Name (Short)">{{org_info.business_name}}</el-form-item>
         <el-form-item label="Legal Company Name">{{ org_info.legal_company_name}}</el-form-item>
         <el-form-item label="Registered address">{{ org_info.address_desc}}</el-form-item>
         <el-form-item label="GST/HST number">{{ org_info.gst_hst_number}}</el-form-item>
         <el-form-item label="Phone number">{{ org_info.phone_code}} {{org_info.phone}}</el-form-item>
         <el-form-item label="Email">{{ org_info.email}}</el-form-item>
       </div>
       <div class="btom_box">
         <div>
           <div class="title">Rate per task</div>
           <div>{{rate_per_task}}</div>
         </div>
         <div>
           <div  class="title">Billing Cycle</div>
           <div>{{billing_cycle_desc}}</div>
         </div>
         <div>
           <div class="title">GST/HST rate in </div>
           <div>{{gst_hst_number}}</div>
         </div>
         <div>
           <div class="title">Amounts are</div>
           <div>{{price_tax_status_desc}}</div>
         </div>
       </div>
     </el-form>
   </el-scrollbar>
   <div class="footer_box" v-if="account_type == 0">
     <el-button type="danger" @click="$emit('openDelete',orgDetial)" plain>Delete</el-button>
     <el-button type="primary" @click="openEditHandle">Edit</el-button>
   </div>
 </div>
</template>

<script>
export default {
  name: "organizationDetial",
  props:{
    orgDetial:{
      default:()=>{}
    }
  },
  data(){
    return{
      org_info:{
        organization_number:'',
        business_name:'',
        legal_company_name:'',
        address_desc:'',
        gst_hst_number:'',
        phone_code:'',
        phone:"",
        email:'',
      },
      rate_per_task:'',
      billing_cycle_desc:'',
      gst_hst_number:'',
      price_tax_status_desc:'',
      account_type:"",
    }
  },
  created() {
    this.org_info = {...this.orgDetial}
    this.rate_per_task = this.orgDetial.rate_per_task
    this.billing_cycle_desc = this.orgDetial.billing_cycle_desc
    this.gst_hst_number = this.orgDetial.gst_hst_number
    this.price_tax_status_desc = this.orgDetial.price_tax_status_desc
   this.account_type = JSON.parse(localStorage.getItem('userInfo')).type
  },
  methods:{
    openEditHandle(){
      this.$emit("openDetial",this.orgDetial)
    },
  }
}
</script>

<style scoped lang="less">
.orgDetialBox{

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  //position: relative;
  /deep/.el-form-item__label{
    font-weight: bold;
  }
  .btom_box{
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    .title{
      font-weight: bold;
      margin-bottom: 16px;
    }
  }
  .footer_box{
    padding-top: 14px;
    width: 100%;
    text-align: right;
    border-top: 1px solid #e0e0e0;
    //position: absolute;
    //bottom: -220px;
  }
}
</style>
